module.exports = __webpack_public_path__ + "img/partner-network.1cc4334d.svg";